import { useSites } from './useSites'

export const useTimezone = (): { timeZone: string | undefined; isFetchingSites: boolean } => {
  const { selectedSite, isFetchingSites } = useSites()
  return { timeZone: selectedSite?.time_zone, isFetchingSites }
}
